import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-27640738"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "loginSuccess resetFooter verify-email-success"
};
const _hoisted_2 = {
  class: "login-top rsTips"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconyuanxingxuanzhongfill"
}, null, -1));

const _hoisted_4 = {
  class: "rsPContent"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("The email account was verified successfully and entered the ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" in 3 seconds. ");

const _hoisted_7 = {
  id: "faq",
  class: "com-div clearfix loginContainer sUp"
};
const _hoisted_8 = {
  class: "loginTips"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi"
}, null, -1));

const _hoisted_10 = {
  id: "error_info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("Sign up")), 1), _hoisted_3, _createElementVNode("p", _hoisted_4, [_hoisted_5, _createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.toLogin && _ctx.toLogin(...args))
  }, "login page"), _hoisted_6]), _createElementVNode("button", {
    class: "login-btn resetFooterBtn",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => _ctx.toLogin && _ctx.toLogin(...args))
  }, "Log in immediately")], 512), [[_vShow, _ctx.showSuccess]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.failMsg), 1)])], 512), [[_vShow, _ctx.showFail]])]);
}